<template>
  <section class="container">
    <div class="justify-content-center">
      <div class="col-md-12" v-if="cargando">
        <div class="row" v-for="i in numero" :key="i">
          <spinner/>
          <spinner  v-for="j in numeros[i]" :key="j"/>
        </div>
      </div>
      <div class="col-md-12" v-else>
        <div class="row justify-content-md-start justify-content-center" v-for="(tipo,index) in vehiculos" :key="index" >
          <div class="btn-titulo bg-primary flecha">
            <v-lazy-image
                    :src="uri + tipo.dt4"
                    :src-placeholder="cargada"
                    :alt="tipo.dt1"
                    class="img-fluid imagen-btn"/>
          </div>
          <boton-auto v-for="vehiculo in tipo.elements" :key="vehiculo.id" :auto="vehiculo" v-on:elegido="clickVehiculo"/>
        </div>
      </div>
    </div>
    <b-modal id="modal-provincia" centered title="Provincia"  hide-footer>
      <p class="my-4">Para ayudarte de mejor manera elige la provincia donde deseas realizar la compra.</p>
      <combo-box v-model="formulario.provincia" :opciones="provincias" name="provincia" v-validate="{required:true,obj:true}"></combo-box>
      <div class="pt-3 d-flex justify-content-end">
        <b-button variant="primary" v-on:click="siguiente">Siguiente</b-button>
      </div>
    </b-modal>
  </section>
</template>
<script>
  import {event} from 'vue-analytics';
  import botonAuto from "../../componentes/boton-auto";
  import comboBox from "../../componentes/comboBox";
  import * as servicios from "../../servicios";
  import spinner from "./spinner";
  import VLazyImage from "v-lazy-image";
  export default {
    name: "Home",
    data: () => ({
      cargada:require("@/assets/images/default_loading.jpg"),
      cargando:true,
      numeros:[],
      numero:Math.floor((Math.random() * 5) + 3),
      uri:process.env.VUE_APP_URL_API,
      vehiculos:[],
      provincias:[],
      formulario:{
        modelo:{id:null},
        provincia:{id:null},
      }
    }),
    components:{
      comboBox,
      botonAuto,
      spinner,
      VLazyImage
    },
    methods:{
      aleatorio : function(){
        for(let i=0;i<this.numero;i++)
          this.numeros.push(Math.floor((Math.random() * 7) + 3));
      },
      consultarVehiculos:function(){
        this.cargando=true;
        servicios.autos.lista().then(response=>{
          this.vehiculos=response.data;
          this.cargando=false;
        });
      },
      consultarProvincias:function(){
        servicios.provincias.provincias().then(response=>{
          this.provincias=response.data;
        });
      },
      clickVehiculo:function(vehiculo){
        this.$root.$emit('bv::show::modal', 'modal-provincia', '#modal-provincia');
        this.formulario.modelo=vehiculo;
        this.$store.commit('limpiar', null);
      },
      siguiente:function(){
        if(this.formulario.provincia.id){
          this.$store.commit('setPaso',{data:this.formulario,p:1});
          this.$store.commit('setActual', 2);
          this.$store.commit('setSubActual',0);
          event({
            category: 'Paso 1',
            action: this.formulario.modelo.dt1,
            label: this.formulario.provincia.dt1
          });
          this.$router.push({ name: 'p2', params: { titulo: this.formulario.modelo.url ,id:this.formulario.modelo.id },hash:"#sub-menu" });
        }
      }
    },
    created() {
      this.aleatorio();
      if(this.$store.getters.getPasos["1"]){
        this.formulario=this.$store.getters.getPasos["1"];
      }
      this.$store.commit('setActual', 1);
      if(this.$route.query.source)
        this.$store.commit("setCampana",this.$route.query.source);
    },
    mounted() {
      this.consultarVehiculos();
      this.consultarProvincias();
    }
  }
</script>
<style scoped>
  .btn-titulo{
    position: relative;
    border: none;
    text-align: center;
    text-decoration: none;
    display: inline-block;
  }
  .margen-h{
    display: table;
    align-items: center
  }

</style>
